(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9296],{

/***/ 62253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ ExternalLinkIcon; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/elements/Icon/ExternalLink/external-link.svg
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    "data-name": "group2691"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "rectangle139",
    d: "M3 1v8h8V1H3M2 0h10v10H2Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "path293",
    d: "M7.83 12H0V4.245h1V11h6.83Z"
  }))));
};
/* harmony default export */ var external_link = (SvgExternalLink);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/Icon/ExternalLink/index.tsx


var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var ExternalLinkIcon = function ExternalLinkIcon(_ref) {
  var size = _ref.size,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIcon, _objectSpread({
    "aria-label": "\u65B0\u898F\u30BF\u30D6\u3067\u958B\u304F",
    size: size
  }, props));
};
var StyledIcon = (0,styled_components_browser_esm/* default */.ZP)(external_link).withConfig({
  displayName: "ExternalLink__StyledIcon",
  componentId: "sc-12ugb1p-0"
})(["transition:fill 0.3s ease-out;fill:", ";width:", ";height:", ";@media screen and (max-width:1047px){width:12px;height:12px;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue, function (_ref2) {
  var size = _ref2.size;
  return size === 'small' ? '12px' : '16px';
}, function (_ref3) {
  var size = _ref3.size;
  return size === 'small' ? '12px' : '16px';
});

/***/ }),

/***/ 53300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ LinkCard; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./src/components/elements/Icon/ExternalLink/index.tsx + 1 modules
var ExternalLink = __webpack_require__(62253);
// EXTERNAL MODULE: ./src/components/elements/RoundedLabel/index.tsx
var RoundedLabel = __webpack_require__(51342);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/LinkCard/Card.tsx






var Card = function Card(_ref) {
  var imgPath = _ref.imgPath,
      title = _ref.title,
      detail = _ref.detail,
      isExternalLink = _ref.isExternalLink;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Grid, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: imgPath,
          width: "100%",
          alt: ""
        })
      }), title && /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
        children: title
      })]
    }), detail && /*#__PURE__*/(0,jsx_runtime.jsx)(Detail, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: detail
        }), isExternalLink && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledExternalLinkIcon, {
          size: "small"
        })]
      })
    })]
  });
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__Wrapper",
  componentId: "sc-1z091jq-0"
})(["width:316px;height:100%;background:", ";border-radius:8px;display:flex;flex-direction:column;@media screen and (max-width:1047px){width:100%;}"], theme/* theme.colors.backgroundPaleBlue */.r.colors.backgroundPaleBlue);
var Grid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__Grid",
  componentId: "sc-1z091jq-1"
})(["display:grid;grid-template-columns:20px 1fr 20px;grid-template-rows:1fr auto 17px;@media screen and (max-width:1047px){grid-template-rows:1fr auto 17px;}"]);
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__ImageWrapper",
  componentId: "sc-1z091jq-2"
})(["display:flex;justify-content:center;grid-area:1 / 1 / 4 / 4;height:188px;transition:opacity 0.25s ease;@media screen and (max-width:1047px){height:199px;}"]);
var Title = (0,styled_components_browser_esm/* default */.ZP)(RoundedLabel/* RoundedLabel */.I).withConfig({
  displayName: "Card__Title",
  componentId: "sc-1z091jq-3"
})(["grid-area:2 / 2 / 3 / 3;"]);
var Detail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__Detail",
  componentId: "sc-1z091jq-4"
})(["background:#fff;padding:18px 26px 22px;border-width:0 4px 4px 4px;border-color:", ";border-style:solid;border-radius:0 0 8px 8px;line-height:1.4;letter-spacing:0.08em;flex:1;@media screen and (max-width:1047px){padding:13px 18px 16px;font-size:14px;}"], theme/* theme.colors.backgroundPaleBlue */.r.colors.backgroundPaleBlue);
var StyledExternalLinkIcon = (0,styled_components_browser_esm/* default */.ZP)(ExternalLink/* ExternalLinkIcon */.h).withConfig({
  displayName: "Card__StyledExternalLinkIcon",
  componentId: "sc-1z091jq-5"
})(["margin-left:8px;"]);
;// CONCATENATED MODULE: ./src/components/elements/LinkCard/index.tsx


var _excluded = ["link", "isExternalLink", "isScroll", "newWindow", "forceReload"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var LinkCard = function LinkCard(_ref) {
  var link = _ref.link,
      isExternalLink = _ref.isExternalLink,
      isScroll = _ref.isScroll,
      newWindow = _ref.newWindow,
      forceReload = _ref.forceReload,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  if (link) {
    if (isExternalLink) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
        href: link,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread(_objectSpread({}, props), {}, {
          isExternalLink: isExternalLink
        }))
      });
    }

    if (isScroll) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledScroll, {
        to: link,
        smooth: true,
        duration: 600,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread({}, props))
      });
    }

    var cardLink = /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
      href: forceReload ? link : undefined,
      target: newWindow ? '_blank' : undefined,
      rel: newWindow ? 'noopener noreferrer' : undefined,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread({}, props))
    });

    if (forceReload) return cardLink;
    return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: link,
      passHref: true,
      children: cardLink
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread({}, props))
  });
};
var LinkStyle = (0,styled_components_browser_esm/* css */.iv)(["display:block;width:316px;white-space:pre-wrap;&:hover > div > div:first-of-type{> div > img{opacity:0.6;transition:opacity 0.25s ease;}> div:nth-of-type(2){background:", ";transition:background 0.25s ease;}}@media screen and (max-width:1047px){width:335px;}"], theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue);
var StyledLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "LinkCard__StyledLink",
  componentId: "sc-1q4bvyj-0"
})(["", ""], LinkStyle);
var StyledScroll = (0,styled_components_browser_esm/* default */.ZP)(modules/* Link */.rU).withConfig({
  displayName: "LinkCard__StyledScroll",
  componentId: "sc-1q4bvyj-1"
})(["", ""], LinkStyle);

/***/ }),

/***/ 51342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ RoundedLabel; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var RoundedLabel = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "RoundedLabel",
  componentId: "sc-1s4si24-0"
})(["color:#fff;background:", ";border-radius:23px;border:2px solid #fff;padding:12px 20px;font-size:17px;line-height:1.1;letter-spacing:0.04em;font-weight:700;word-break:break-all;text-align:center;position:relative;transition:background 0.25s ease;@media screen and (max-width:1047px){border-radius:25px;font-size:15px;padding:12px 50px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);

/***/ }),

/***/ 70770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SectionTitle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var SectionTitle = function SectionTitle(_ref) {
  var titleText = _ref.titleText,
      subTitleText = _ref.subTitleText,
      enTitleText = _ref.enTitleText,
      color = _ref.color,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'h3' : _ref$as;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SectionTitleDiv, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleText, {
      color: color,
      as: as,
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EnTitleText, {
      color: color,
      as: as,
      children: enTitleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubTitleText, {
      color: color,
      children: subTitleText
    })]
  });
};
var SectionTitleDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitle__SectionTitleDiv",
  componentId: "sc-17562y0-0"
})(["text-align:center;"]);
var TitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__TitleText",
  componentId: "sc-17562y0-1"
})(["font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";@media screen and (max-width:1047px){display:none;}"], function (_ref2) {
  var color = _ref2.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);
var SubTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "SectionTitle__SubTitleText",
  componentId: "sc-17562y0-2"
})(["font-size:18px;line-height:26px;color:", ";@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref3) {
  var color = _ref3.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.overlay */ .r.colors.overlay) : "white";
});
var EnTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__EnTitleText",
  componentId: "sc-17562y0-3"
})(["@media screen and (min-width:1048px){font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";}@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref4) {
  var color = _ref4.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);

/***/ }),

/***/ 5801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ CompanyLinks; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32125);
/* harmony import */ var _utils_enroutes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9058);
/* harmony import */ var _components_elements_LinkCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53300);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var CompanyLinks = function CompanyLinks(_ref) {
  var padding = _ref.padding;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(CompanyNaviListWrapper, {
    padding: padding,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(CompanyNaviList, {
      children: _utils_enroutes__WEBPACK_IMPORTED_MODULE_0__/* .COMPANY_ROUTE.subdirectories.map */ .Ir.subdirectories.map(function (_ref2) {
        var path = _ref2.path,
            name = _ref2.name,
            imagePath = _ref2.imagePath;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_components_elements_LinkCard__WEBPACK_IMPORTED_MODULE_1__/* .LinkCard */ .k, {
            link: path,
            title: name,
            imgPath: imagePath
          })
        }, name);
      })
    })
  });
};
var CompanyNaviListWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CompanyLinks__CompanyNaviListWrapper",
  componentId: "sc-vltl97-0"
})(["margin:0 auto;padding:", ";width:1040px;@media screen and (max-width:1047px){padding:", ";width:100%;display:", ";}"], function (_ref3) {
  var padding = _ref3.padding;
  return padding.pc;
}, function (_ref4) {
  var padding = _ref4.padding;
  return padding.sp;
}, function (_ref5) {
  var padding = _ref5.padding;
  return !padding.sp && 'none';
});
var CompanyNaviList = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
  displayName: "CompanyLinks__CompanyNaviList",
  componentId: "sc-vltl97-1"
})(["display:flex;flex-wrap:wrap;gap:66px 46px;@media screen and (max-width:1047px){justify-content:center;gap:38px;li:nth-child(odd):last-child{margin-right:388px;}}@media screen and (max-width:700px){li:nth-child(odd):last-child{margin-right:0;}}"]);

/***/ }),

/***/ 32056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | TRIAL Holdings, Inc.") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 94470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ PhilosophyPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/enpages/Company/Philosophy/ExplanationItem.tsx




var ExplanationItem = function ExplanationItem(_ref) {
  var mainTitle = _ref.mainTitle,
      subTitle = _ref.subTitle,
      text = _ref.text;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ExplanationItemStyled, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h4", {
      children: [mainTitle, /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: subTitle
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: text
    })]
  });
};
var ExplanationItemStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExplanationItem__ExplanationItemStyled",
  componentId: "sc-k9mirh-0"
})(["h4{font-size:25px;color:", ";font-weight:bold;font-family:", ";line-height:1;margin-bottom:10px;}span{margin-left:16px;font-size:20px;color:#3786c7;font-weight:normal;}p{font-size:18px;line-height:1.5;}& + &{margin-top:40px;}@media screen and (max-width:1047px){h4{font-size:20px;margin-bottom:8px;}span{font-size:18px;}p{font-size:15px;}& + &{margin-top:26px;}}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue, theme/* theme.fontEn */.r.fontEn);
;// CONCATENATED MODULE: ./src/components/enpages/Company/Philosophy/TalkList.tsx



var TalkList = function TalkList(_ref) {
  var talkTitle = _ref.talkTitle,
      talkList = _ref.talkList;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TalkListStyled, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TalkTitle, {
      children: talkTitle
    }), talkList.map(function (_ref2) {
      var id = _ref2.id,
          nameColor = _ref2.nameColor,
          name = _ref2.name,
          talkContent = _ref2.talkContent;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(TalkContent, {
        color: nameColor,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          children: [name, " :"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: talkContent
        })]
      }, id);
    })]
  });
};
var TalkListStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TalkList__TalkListStyled",
  componentId: "sc-ikkt8b-0"
})(["padding-bottom:90px;&:last-child{padding-bottom:0;}@media screen and (max-width:1047px){padding-bottom:46px;}"]);
var TalkTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
  displayName: "TalkList__TalkTitle",
  componentId: "sc-ikkt8b-1"
})(["font-weight:bold;font-size:26px;border-bottom:1px solid #c0c0c0;padding-bottom:20px;position:relative;@media screen and (max-width:1047px){font-size:20px;padding-bottom:12px;&::after{top:44%;}}"]);
var TalkContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TalkList__TalkContent",
  componentId: "sc-ikkt8b-2"
})(["display:flex;gap:15px;padding-top:40px;p{font-size:18px;line-height:1.8;}p:nth-of-type(1){color:", ";white-space:nowrap;font-weight:bold;}@media screen and (max-width:1047px){padding-top:24px;gap:5px;p{font-size:14px;}}"], function (_ref3) {
  var color = _ref3.color;
  return color;
});
;// CONCATENATED MODULE: ./src/components/enpages/Company/Philosophy/talkLists.tsx



var talkItemList = [{
  talkTitle: 'What drove us?',
  talkList: [{
    id: '1',
    nameColor: '#002D65',
    name: 'Hiro',
    talkContent: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: "TRIAL Group is commemorating its 40th anniversary and getting ready for the next stage. We wanted to establish a common language within the company and work to permeate its understanding. It helps us to leap toward the new stage through \"TRIAL\" and error."
    })
  }]
}, {
  talkTitle: 'Looking back the process.',
  talkList: [{
    id: '1',
    nameColor: '#3786c7',
    name: 'Ishibashi',
    talkContent: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["There are \"things to change\" with the times changes and \"things should not change\" as founding philosophy.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "We put efforts in our choice of words, but most importantly we spent a lot of time distinguishing things whether we change or not."]
    })
  }]
}, {
  talkTitle: 'Thoughts in Words',
  talkList: [{
    id: '1',
    nameColor: '#002D65',
    name: 'Hiro',
    talkContent: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["Each of our Purpose, Vision, and Values has a key message, as the Purpose expresses \u201CEnrich every aspect of people's lives through all we do.\u201D", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "We are not only making benefits but also putting efforts on creating a positive impact on the society and in the world through this activity. That is our raison d'\xEAtre."]
    })
  }]
}, {
  talkTitle: 'The Keyword',
  talkList: [{
    id: '1',
    nameColor: '#3786c7',
    name: 'Ishibashi',
    talkContent: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["It is \"Practical savvy\u201D.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "It tells you that we value the \"Practical savvy\" as well as technology. We carefully selected the word both in Japanese and English."]
    })
  }, {
    id: '2',
    nameColor: '#002D65',
    name: 'Hiro',
    talkContent: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["\"Practical savvy\" describes our company's unique characteristics well. We chose the word \"savvy\" over \"experience\" because we evaluate our growth based on what we learned through TRIALs and errors.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "It expresses the message we fearlessly take on new challenges while incorporating the latest technology."]
    })
  }]
}, {
  talkTitle: 'How We Penetrate Philosophy into Business',
  talkList: [{
    id: '1',
    nameColor: '#002D65',
    name: 'Hiro',
    talkContent: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["It is important to act under our \"purpose,\" \"vision,\" and \"value\". To fulfill our philosophy, we offer customers valuable shopping experiences assisted by technology.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Retail business and Retail AI business are sharing same goals even though their business fields are different. We can achieve our vision and value by having business synergy."]
    })
  }, {
    id: '2',
    nameColor: '#3786c7',
    name: 'Ishibashi',
    talkContent: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["We use our philosophy to enhance contribution for customers.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Day-to-day store operation is shaping tomorrow in the retail business. Awareness that every one of us have led to the future."]
    })
  }]
}, {
  talkTitle: 'What is TRIAL business style?',
  talkList: [{
    id: '1',
    nameColor: '#002D65',
    name: 'Hiro',
    talkContent: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["The word \"technology\" in the vision explains studying the distribution platform. Our purpose and vision are what we will achieve over the long term.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "With our global experiences, we adopted words \"World\" and \"Technology\" into our Philosophy."]
    })
  }, {
    id: '2',
    nameColor: '#3786c7',
    name: 'Ishibashi',
    talkContent: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["We are working onto current business and future business simultaneously.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "We move forward both real stores and digital data at the same time. It is in our \"Value\". This is what TRIAL is all about."]
    })
  }]
}];
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/enlayout.tsx + 7 modules
var enlayout = __webpack_require__(34591);
// EXTERNAL MODULE: ./src/components/enlayouts/Company/CompanyLinks/index.tsx
var CompanyLinks = __webpack_require__(5801);
// EXTERNAL MODULE: ./src/components/enlayouts/Head/index.tsx
var Head = __webpack_require__(32056);
;// CONCATENATED MODULE: ./src/components/enpages/Company/Philosophy/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var PhilosophyPage = function PhilosophyPage() {
  var explanationItemList = [{
    mainTitle: 'Purpose',
    text: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: "Enrich every aspect of people's lives through all we do."
    })
  }, {
    mainTitle: 'Vision',
    text: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: "Revolutionize \"real commerce\" around the globe with technology and practical savvy."
    })
  }, {
    mainTitle: 'Value',
    text: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["\u30FBThe power to distribute goods with our highly efficient network of stores", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u30FBThe ability to fully leverage data and IoT"]
    })
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "Philosophy",
      description: "Our group's purpose, vision, and values.",
      ogp: {
        type: 'article',
        url: 'en/company/philosophy/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PhilosophyMainWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(PhilosophyMain, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
          enTitleText: "Philosophy",
          subTitleText: "",
          color: "normal"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Philosophy, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
            children: "Purpose, Vision & Value"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PhilosophyTriangle, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageWrapper, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: "/images/Philosophy_EN.svg",
                alt: "TRIAL Holdings\u306E\u30D1\u30FC\u30D1\u30B9\u30FB\u30D3\u30B8\u30E7\u30F3\u30FB\u30D0\u30EA\u30E5\u30FC"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Explanation, {
              children: explanationItemList.map(function (_ref) {
                var mainTitle = _ref.mainTitle,
                    text = _ref.text;
                return /*#__PURE__*/(0,jsx_runtime.jsx)(ExplanationItem, {
                  mainTitle: mainTitle,
                  text: text
                }, mainTitle);
              })
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SpecialTalk, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
            children: "Special Talk"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(NameWrapper, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Name, {
              "data-left": true,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: ["Director", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " Ryota Ishibashi"]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Name, {
              "data-right": true,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: ["Director", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " Hiro Nagata"]
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
            h: {
              sp: 60,
              pc: 70
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "/images/philosophy-talk.webp",
            alt: "PhilosophyTalk\u753B\u50CF"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
            h: {
              sp: 34,
              pc: 60
            }
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TalkMain, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TalkLead, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h3", {
              children: ["How our Purpose, Vision and Value are created. TRIAL Holdings.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " ~Thoughts behind our philosophy~"]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              children: ["\"Purpose\" for corporate management is attracting attention. It represents the value to the society while clarifying the importance of each company.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Having clear \"Vision\" and \"Value\" unifies the organization."]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              children: ["The \"Purpose, Vision, and Value\" at TRIAL Holdings represents the passion of each of executive directors which emerged through deep r discussions.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Ryota Ishibashi, Director, and Hiro Nagata, Director, talk about the secret story behind the scenes."]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
            h: {
              sp: 56,
              pc: 110
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Talk, {
            children: [talkItemList.map(function (_ref2) {
              var talkTitle = _ref2.talkTitle,
                  talkList = _ref2.talkList;
              return /*#__PURE__*/(0,jsx_runtime.jsx)(TalkList, {
                talkTitle: talkTitle,
                talkList: talkList
              }, talkTitle);
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                style: {
                  textAlign: 'right'
                },
                children: "December 2022"
              })
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyLinks/* CompanyLinks */.b, {
        padding: {
          pc: '130px 0 0'
        }
      })]
    })]
  });
};

PhilosophyPage.getLayout = function getLayout(page) {
  var pageTitle = {
    title: 'Corporate Information',
    subTitle: ''
  };
  var breadCrumbs = [{
    name: 'Home',
    path: '/en/'
  }, {
    name: 'Corporate Information',
    path: '/en/company/'
  }, {
    name: 'Philosophy',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(enlayout/* TitleLayout */.$0, _objectSpread(_objectSpread({}, pageTitle), {}, {
    breadCrumbs: breadCrumbs,
    isRequiredBackground: true,
    children: page
  }));
};

var PhilosophyMainWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Philosophy__PhilosophyMainWrapper",
  componentId: "sc-13y4u49-0"
})(["width:1040px;padding-bottom:130px;margin:0 auto 0;@media screen and (max-width:1047px){width:100%;margin:0 auto 0;padding:0 20px 70px;}"]);
var PhilosophyMain = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Philosophy__PhilosophyMain",
  componentId: "sc-13y4u49-1"
})(["margin-top:78px;@media screen and (max-width:1047px){margin-top:40px;}"]);
var Philosophy = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "Philosophy",
  componentId: "sc-13y4u49-2"
})(["margin-top:132px;background-color:", ";padding:70px;h3{color:", ";font-size:28px;font-weight:bold;text-align:center;line-height:1.2;}@media screen and (max-width:1047px){margin-top:70px;padding:40px 20px;h3{font-size:20px;}}"], theme/* theme.colors.backgroundGrey */.r.colors.backgroundGrey, theme/* theme.colors.trialBlue */.r.colors.trialBlue);
var PhilosophyTriangle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Philosophy__PhilosophyTriangle",
  componentId: "sc-13y4u49-3"
})(["margin-top:80px;display:flex;gap:80px;@media screen and (max-width:1047px){flex-direction:column;align-items:center;margin-top:40px;gap:40px;}"]);
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Philosophy__ImageWrapper",
  componentId: "sc-13y4u49-4"
})(["width:440px;height:340px;@media screen and (max-width:1047px){width:295px;height:228px;img{width:100%;height:100%;}}"]);
var Explanation = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Philosophy__Explanation",
  componentId: "sc-13y4u49-5"
})([""]);
var SpecialTalk = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "Philosophy__SpecialTalk",
  componentId: "sc-13y4u49-6"
})(["margin-top:130px;h3{font-size:22px;color:#3786c7;line-height:32px;text-align:center;font-family:", ";}span{display:block;font-size:18px;line-height:1;color:", ";}img{width:100%;}@media screen and (max-width:1047px){margin-top:65px;h3{font-size:18px;}span{font-size:12px;}}"], theme/* theme.fontEn */.r.fontEn, theme/* theme.colors.textTitle */.r.colors.textTitle);
var NameWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Philosophy__NameWrapper",
  componentId: "sc-13y4u49-7"
})(["margin-top:46px;display:flex;justify-content:center;gap:93px;@media screen and (max-width:1047px){flex-direction:column;align-items:center;gap:49px;}"]);
var Name = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Philosophy__Name",
  componentId: "sc-13y4u49-8"
})(["width:274px;height:64px;padding:17px 25px;position:relative;p{color:#fff;font-size:26px;line-height:1;margin-top:-12px;}&[data-left]{background-color:#3786c7;&::after{content:'';width:0;height:0;border-style:solid;border-width:32px 0 32px 30px;border-color:transparent transparent transparent #3786c7;display:inline-block;position:absolute;right:-30px;top:0;}&::before{content:'';height:2px;width:90px;background-color:#3786c7;transform:rotate(45deg);display:inline-block;position:absolute;top:31px;right:-91px;}}&[data-right]{background-color:", ";&::after{content:'';width:0;height:0;border-style:solid;border-width:32px 30px 32px 0;border-color:transparent ", " transparent transparent;display:inline-block;position:absolute;left:-30px;top:0;}&::before{content:'';height:2px;width:90px;background-color:", ";transform:rotate(-45deg);display:inline-block;position:absolute;top:31px;left:-91px;}}@media screen and (max-width:1047px){height:50px;padding:13px 50px 12px;p{font-size:22px;}&[data-left]::after,&[data-right]::after{display:none;}&[data-left]::before{width:35px;top:85px;left:50%;transform:rotate(45deg) translateX(-50%);}&[data-right]::before{width:35px;top:-39px;left:50%;transform:rotate(-45deg) translateX(-50%);}}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue, theme/* theme.colors.trialBlue */.r.colors.trialBlue, theme/* theme.colors.trialBlue */.r.colors.trialBlue);
var TalkMain = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "Philosophy__TalkMain",
  componentId: "sc-13y4u49-9"
})([""]);
var TalkLead = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Philosophy__TalkLead",
  componentId: "sc-13y4u49-10"
})(["h3{color:", ";font-size:28px;font-weight:bold;margin-bottom:40px;}p{font-size:18px;line-height:2;& + p{margin-top:30px;}}@media screen and (max-width:1047px){h3{font-size:20px;margin-bottom:20px;}p{font-size:15px;line-height:1.8;& + p{margin-top:20px;}}}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue);
var Talk = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Philosophy__Talk",
  componentId: "sc-13y4u49-11"
})([""]);
;// CONCATENATED MODULE: ./src/pages/en/company/philosophy.tsx


/***/ }),

/***/ 1345:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/company/philosophy",
      function () {
        return __webpack_require__(94470);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,8517,4591,9774,2888,179], function() { return __webpack_exec__(1345); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);